import script from "./TasksList.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksList.vue?vue&type=script&setup=true&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=12fa022e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fa022e"]])

export default __exports__